import React from "react";

//===IMPORT COMPONENT====
import firstEllipse from "../../assets/Ellipse.svg";
import secondEllipse from "../../assets/Ellipse-1.svg";
import logo from "../../assets/Logo.svg";
import { useTranslation } from "react-i18next";
import Crypto from "../../assets/Crypto";
import {
  FirstPage3Button,
  SecondPage3Button,
  Page3ButtonContainer,
  Page3Captions,
  Page3Card,
  Page3CardCaption,
  Page3Container,
  Page3Content,
  Page3Head,
  Page3HeadWrapper,
  Page3Wrapper,
  PageFirstTextCaption,
  PageFirstTextSpan,
  PageSecondTextCaption,
  WalletContainer,
  WalletIcon,
  WalletType,
  FirstEllipseContainer,
  SecondEllipseContainer,
  Logo,
} from "./signInStyles";



const Page3 = () => {
  const { t } = useTranslation();

  return (
    <>
      <Page3Container>
        <Page3Head>
              <Page3HeadWrapper>
                <FirstEllipseContainer src={firstEllipse} />
                <SecondEllipseContainer src={secondEllipse} />
                <Logo src={logo} />
              </Page3HeadWrapper>
        </Page3Head>
        <Page3Wrapper>
          <Page3Content>
            <Page3Captions>
              <PageFirstTextCaption>
                {t("page3.page3FirstCaption.h1")}
                <PageFirstTextSpan>
                  {t("page3.page3FirstCaption.span")}
                </PageFirstTextSpan>
              </PageFirstTextCaption>
              <PageSecondTextCaption>
                {t("page3.page3SecondCaption")}
              </PageSecondTextCaption>
            </Page3Captions>
          </Page3Content>
          <Page3Card>
            <Page3CardCaption>{t("page3.page3CardCaption")}</Page3CardCaption>
            <WalletContainer>
              <WalletType>
                <WalletIcon>
                  <Crypto />
                </WalletIcon>
                {t("page3.walletType.wallet1")}
              </WalletType>
              <WalletType>
                <WalletIcon>
                  <Crypto />
                </WalletIcon>
                {t("page3.walletType.wallet2")}
              </WalletType>
              <WalletType>
                <WalletIcon>
                  <Crypto />
                </WalletIcon>
                {t("page3.walletType.wallet3")}
              </WalletType>
              <WalletType>
                <WalletIcon>
                  <Crypto />
                </WalletIcon>
                {t("page3.walletType.wallet4")}
              </WalletType>
            </WalletContainer>
            <Page3ButtonContainer>
              <FirstPage3Button>Go Back</FirstPage3Button>
              <SecondPage3Button>Continue</SecondPage3Button>
            </Page3ButtonContainer>
          </Page3Card>
        </Page3Wrapper>
      </Page3Container>
    </>
  );
};

export default Page3;
